export const BIZ_ORG_ID = {
    YINGCAI: "1955561580326301697",
}
